import Card from 'blocks/Card';
import { AwardTicketsContext } from 'context/AwardTicketsProvider';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import ajax from 'utils/ajax';
import urls from 'utils/urls';
import { AwardTicketsFormModel, FareFlightInterface } from '../../awardTicket.interface';

interface Props {
  goToNextStep: () => void;
}

const Step1: React.FC<Props> = ({ goToNextStep }) => {
  const methods = useForm<AwardTicketsFormModel>();
  const { handleSubmit, register, setValue, watch } = methods;

  const awardTicketContext = useContext(AwardTicketsContext);

  const [showModalPassengerCount, setShowModalPassengerCount] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: AwardTicketsFormModel) => {
    setLoading(true);

    let params = `?departure=${data.departure}`;

    if (data.destination) params += `&destination=${data.destination}`;
    if (data.dateTime) params += `&dateTime=${data.dateTime.replaceAll('/', '-')}`;
    if (data.adtCount) params += `&adtCount=${data.adtCount}`;
    if (data.chdCount) params += `&chdCount=${data.chdCount}`;
    if (data.infCount) params += `&infCount=${data.infCount}`;
    if (data.cabinClass) params += ``;
    // if(data.searchType) params += `&searchType=STANDARD`
    params += `&searchType=STANDARD`;

    const res = await ajax<Array<FareFlightInterface>>({
      url: urls.awardTicket + params,
      method: 'GET',
    }).finally(() => setLoading(false));

    if (!res) return;

    goToNextStep();

    awardTicketContext.updateGloablDataForm(data);
    awardTicketContext.setFareFlights(res);
  };

  return (
    <Card>
      {/* <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <InputWrapper>
                        <SelectField
                            control={register('departure')}
                            label='Flying From'
                            placeholder='Where would you like to fly from?'
                            onChange={(value: string) => setValue('departure', value)}
                            apiUrl={urls.departureRoute}
                            requestOnce
                            autoCompelete
                        />
                        <SelectField
                            control={register('destination')}
                            label='Flying to'
                            placeholder='Where do you want to go?'
                            onChange={(value: string) => setValue('destination', value)}
                            apiUrl={urls.destinationRoute(watch('departure'))}
                            autoCompelete
                        />
                        <DatePicker
                            control={register('dateTime')}
                            label='Outbound'
                            onChange={(date: string) => setValue('dateTime', getDate(date))}
                        />
                    </InputWrapper>

                    <InputWrapper>
                        <SelectField
                            control={register('cabinClass')}
                            menu={CABIN_CLASS}
                            onChange={(value: string) => setValue('cabinClass', value)}
                            label='Cabin class'
                        />
                        <TextField
                            label='Guests'
                            readonly
                            onClick={() => setShowModalPassengerCount(true)}
                        />
                    </InputWrapper>

                    <ButtonWrapper justify='flex-start'>
                        <Button
                            type='submit'
                            width={147}
                            loading={loading}
                        >Search flights</Button>
                    </ButtonWrapper>

                    <ModalPassengerCount
                        open={showModalPassengerCount}
                        onClose={() => setShowModalPassengerCount(false)}
                    />
                </Form>
            </FormProvider> */}
    </Card>
  );
};

export default Step1;
